// extracted by mini-css-extract-plugin
module.exports = {"replaceList":"style__replaceList__UGxR0"};